import React from 'react';

import CollapsableStepPlan from './StepPlan';
import CollapsableStepPlanIcon from './StepPlanIcon';
import CollapsableGeneric from './Generic';

const Collapsable = (props) => {
  const { type } = props;

  switch (type) {
    case 'stepplan':
      return <CollapsableStepPlan {...props} />;
    case 'stepplan_icon':
      return <CollapsableStepPlanIcon {...props} />;
    default:
      return <CollapsableGeneric {...props} />;
  }
};

export default Collapsable;
